export default "__VITE_ASSET__bca23dab__"